import { render, staticRenderFns } from "./PurchaseSuggestion.vue?vue&type=template&id=7b6f410c&scoped=true&"
import script from "./PurchaseSuggestion.vue?vue&type=script&lang=js&"
export * from "./PurchaseSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSuggestion.vue?vue&type=style&index=0&id=7b6f410c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f410c",
  null
  
)

export default component.exports
import {QBreadcrumbs,QBreadcrumbsEl,QBtn,QSpinner,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QBreadcrumbsEl,QBtn,QSpinner,QTable})
